import { useCart } from "lib/hooks/useCart";
import { CldImage } from "next-cloudinary";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { AiTwotoneEdit } from "react-icons/ai";
import { IoMdTrash } from "react-icons/io";
const CartItemInputs = dynamic(() => import("./CartItemInputs"));

import styles from "./CartItem.module.scss";
import CartItemOptions from "./CartItemOptions";
const CartItemModal = dynamic(() => import("./CartItemModal"));

export default function CartItem({
  title,
  slug,
  image,
  type,
  subtitleText,
  cartId,
  currency,
  price,
  unitPrice,
  inputs,
  options,
  handleOptionsChange,
}) {
  const [isOptionsModalOpen, setIsOptionsModalOpen] = useState(false);

  const { deleteFromCart } = useCart();

  const handleRemoveButtonClick = async () => {
    await deleteFromCart({ cartIds: [cartId] });
  };

  const openEditOptionsModal = () => {
    setIsOptionsModalOpen(true);
  };

  const closeEditOptionsModal = () => {
    setIsOptionsModalOpen(false);
  };

  const handleEditOptionsClick = () => {
    openEditOptionsModal();
  };

  return (
    <article
      className={`${styles.container} ${
        isOptionsModalOpen ? styles.highlight : ""
      }`}
    >
      <div className={`${styles.cardLayout}`}>
        {image && (
          <Link href={`/${slug}`} className={`${styles.imageWrapper}`}>
            <CldImage
              src={image}
              alt={title}
              className={styles.image}
              width={640}
              height={360}
              crop="lfill,ar_1.78"
              sizes={`
        (min-width: 1200px) 380px,
        (min-width: 768px) 30vw, 
        (min-width: 515px) 45vw,
        (max-width: 515px) 100vw, 
        380px`}
            />
          </Link>
        )}

        <div className={`${styles.productInfo}`}>
          <div className={`${styles.column} ${styles.leftColumn}`}>
            <div className={`${styles.row} ${styles.titleRow}`}>
              <Link href={`/${slug}`}>
                <span className={`${styles.title}`}>{title}</span>
              </Link>
              <div className={`${styles.subtitle}`}>
                <span className={`${styles.type}`}>
                  {type === "experience" && (
                    <span className={`${styles.locationIcon}`}>
                      <Image
                        src="/assets/img/icons/map-pin-black.svg"
                        alt="Location icon"
                        width="15"
                        height="15"
                      />
                    </span>
                  )}
                </span>
                <span>{subtitleText}</span>
              </div>
            </div>
            <div className={`${styles.cartOptionsRow}`}>
              <CartItemOptions
                options={
                  (options = inputs.map((input) => {
                    return {
                      ...input,
                      value: options[input.id],
                    };
                  }))
                }
                openModal={openEditOptionsModal}
              />
            </div>
          </div>

          <div className={`${styles.column} ${styles.rightColumn}`}>
            <div className={`${styles.cartActionButtons}`}>
              <button
                className={`${styles.cartOperationButton}`}
                onClick={handleEditOptionsClick}
              >
                <AiTwotoneEdit size={20} />
              </button>
              <button
                className={`${styles.cartOperationButton}`}
                onClick={handleRemoveButtonClick}
              >
                <IoMdTrash size={20} />
              </button>
            </div>

            <div className={`${styles.priceContainer}`}>
              <span className={`${styles.label}`}>Subtotal</span>
              <span className={`${styles.price}`}>{price}</span>
            </div>
          </div>

          <CartItemModal
            isOpen={isOptionsModalOpen}
            onClose={closeEditOptionsModal}
            title={title}
            price={price}
          >
            <CartItemInputs
              options={options}
              handleOptionsChange={handleOptionsChange}
              inputs={inputs}
            />
          </CartItemModal>
        </div>
      </div>
    </article>
  );
}
